"use client";

import { c as _c } from "react/compiler-runtime";
import { Input } from "@/components/rac/input";
import { Label } from "@/components/rac/label";
import { useAuth } from "@/hooks/use-auth";
import { useState } from "react";
const defaultError = {
  name: "",
  email: ""
};
interface EmailSubmissionProps {
  name?: string;
  email?: string;
  setName: (name: string) => void;
  setEmail: (email: string) => void;
}
export function EmailSubmission(t0) {
  const $ = _c(22);
  const {
    name,
    email,
    setName,
    setEmail
  } = t0;
  const {
    user
  } = useAuth();
  const userName = user?.name;
  const [error, setError] = useState(defaultError);
  let t1;
  if ($[0] !== userName) {
    t1 = userName && userName !== "<No Name>" && userName.trim() !== "";
    $[0] = userName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const hasValidUserName = t1;
  const showNameField = !hasValidUserName;
  let t2;
  if ($[2] !== error || $[3] !== name || $[4] !== setName || $[5] !== showNameField) {
    t2 = showNameField && <div className="space-y-2"><Label htmlFor="name" className="text-sm font-medium text-gray-700">Name</Label><Input id="name" type="text" placeholder="Enter your name" value={name || ""} onChange={e => {
        setName(e.target.value);
        if (error.name) {
          setError({
            ...error,
            name: ""
          });
        }
      }} className="w-full" />{error.name && <p className="text-sm text-red-600">{error.name}</p>}</div>;
    $[2] = error;
    $[3] = name;
    $[4] = setName;
    $[5] = showNameField;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Label htmlFor="email" className="text-sm font-medium text-gray-700">Email Address</Label>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const t4 = email || "";
  let t5;
  if ($[8] !== error || $[9] !== setEmail) {
    t5 = e_0 => {
      setEmail(e_0.target.value);
      if (error.email) {
        setError({
          ...error,
          email: ""
        });
      }
    };
    $[8] = error;
    $[9] = setEmail;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t4 || $[12] !== t5) {
    t6 = <Input id="email" type="email" placeholder="Enter your email address" value={t4} onChange={t5} className="w-full" />;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== error.email) {
    t7 = error.email && <p className="text-sm text-red-600">{error.email}</p>;
    $[14] = error.email;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t6 || $[17] !== t7) {
    t8 = <div className="space-y-2">{t3}{t6}{t7}</div>;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== t2 || $[20] !== t8) {
    t9 = <div className="space-y-1"><div className="space-y-4">{t2}{t8}</div></div>;
    $[19] = t2;
    $[20] = t8;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  return t9;
}